<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>An Introduction to the Scriptures of Israel: History and Theology</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb1" id="pre1"><a id="page_v"></a><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc1" id="abb1"><a href="#/xhtml/abbreviations#abb">Abbreviations</a></p>
<p class="Toc" id="c1"><a href="#/xhtml/chapter001#ch01">1.<span class="space">Three Introductions</span></a></p>
<p class="Toc" id="c2"><a href="#/xhtml/chapter002#ch02">2.<span class="space">The Wisdom Tradition: Religion without Revelation</span></a></p>
<p class="Toc" id="c3"><span href="#/xhtml/chapter003#ch03" title="Link target outside of Sample">3.<span class="space">Revelation and Love: The Patriarchal Narratives and the Song of Songs</span></span></p>
<p class="Toc" id="c4"><span href="#/xhtml/chapter004#ch04" title="Link target outside of Sample">4.<span class="space">Joseph and Narrative</span></span></p>
<p class="Toc" id="c5"><span href="#/xhtml/chapter005#ch05" title="Link target outside of Sample">5.<span class="space">The Exodus: Freedom and Sonship</span></span></p>
<p class="Toc" id="c6"><span href="#/xhtml/chapter006#ch06" title="Link target outside of Sample">6.<span class="space">Sinai: Covenant and Code</span></span></p>
<p class="Toc" id="c7"><span href="#/xhtml/chapter007#ch07" title="Link target outside of Sample">7.<span class="space">The Problem of Monarchy: Samuel and Kings</span></span></p>
<p class="Toc" id="c8"><span href="#/xhtml/chapter008#ch08" title="Link target outside of Sample">8.<span class="space">Condemning Israel, Sparing the Nations: Amos and Jonah</span></span></p>
<p class="Toc" id="c9"><span href="#/xhtml/chapter009#ch09" title="Link target outside of Sample">9.<span class="space">Eden and the Art of Reading</span></span></p>
<p class="Toc2" id="c10"><span href="#/xhtml/chapter010#ch10" title="Link target outside of Sample">10.<span class="space">Priestly Theology and Holy Space</span></span></p>
<p class="Toc2" id="c11"><span href="#/xhtml/chapter011#ch11" title="Link target outside of Sample">11.<span class="space">Exile and Return: Prophetic Visions</span></span></p>
<p class="Toc2" id="c12"><span href="#/xhtml/chapter012#ch12" title="Link target outside of Sample">12.<span class="space">The Consolidation of Judaism: Temple and Torah</span></span></p>
<p class="Toc2" id="c13"><a id="page_vi"></a><span href="#/xhtml/chapter013#ch13" title="Link target outside of Sample">13.<span class="space">Violence and Identity: Joshua and Judges</span></span></p>
<p class="Toc2" id="c14"><span href="#/xhtml/chapter014#ch14" title="Link target outside of Sample">14.<span class="space">Jews, Gentiles, and Gender: Esther, Ruth, Ezra, and Nehemiah</span></span></p>
<p class="Toc2" id="c15"><span href="#/xhtml/chapter015#ch15" title="Link target outside of Sample">15.<span class="space">Apocalyptic: Daniel and the Dead Sea Scrolls</span></span></p>
<p class="Toc2" id="c16"><span href="#/xhtml/chapter016#ch16" title="Link target outside of Sample">16.<span class="space">The Israelite at Prayer: The Book of Psalms</span></span></p>
<p class="Toc3" id="ind1_1"><span href="#/xhtml/index001#ind1-1" title="Link target outside of Sample">Subject Index</span></p>
<p class="Toc3" id="ind1_2"><span href="#/xhtml/index002#ind1-2" title="Link target outside of Sample">Scripture and Other Ancient Sources Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2814d327